import styled, { css } from "styled-components";
import { TypographyV2 } from "config/font";
import { ColorV2 } from "config/colors";
import { mediaMax } from "components/designV2/breakpoints";

type ShiftBlockSize = "small" | "large" | "pill";

export const Block = styled.div<{
  $size: ShiftBlockSize;
  $backgroundColor: string;
  $textColor: string;
  $clickable: boolean;
}>`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 6px;
  background-color: ${(props) => props.$backgroundColor};
  color: ${(props) => props.$textColor};
  box-sizing: border-box;
  cursor: ${(props) => (props.$clickable ? "pointer" : "default")};
  position: relative;
  border-radius: 16px;
  width: 100%;

  &:focus-visible {
    outline: 2px solid ${(props) => props.$textColor};
    outline-offset: 2px;
  }

  ${(props) =>
    props.$clickable &&
    css`
      &:hover {
        filter: brightness(0.92);
      }
    `}

  ${(props) =>
    props.$size === "large" &&
    css`
      padding: 8px 10px;
      ${mediaMax.desktopMedium} {
        padding: 6px 8px;
      }
    `}

  ${(props) =>
    props.$size === "small" &&
    css`
      padding: 4px 10px;
      container-type: inline-size;
      container-name: shift-small-block;
    `}

  ${(props) =>
    props.$size === "pill" &&
    css`
      width: 24px;
      height: 26px;
      border-radius: 8px;
    `}
`;

export const TimeText = styled.div`
  ${TypographyV2.b1};
  max-width: 100%;
  overflow-wrap: anywhere;

  @container shift-small-block (min-width: 0) {
    font-size: clamp(10px, 14cqi, 16px);
    line-height: 1.15;
  }
`;

export const StatusText = styled.div`
  ${TypographyV2.s1};
  max-width: 100%;
  overflow-wrap: anywhere;

  ${mediaMax.desktop} {
    display: none;
  }
`;

export const TooltipContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: inherit;
  gap: 4px;
  text-align: inherit;
  width: 100%;
`;

export const TooltipDate = styled.div`
  ${TypographyV2.s1};
  opacity: 0.7;
  width: 100%;
`;

export const TooltipTime = styled.div`
  ${TypographyV2.b1};
  width: 100%;
  white-space: nowrap;
`;

export const TooltipStatus = styled.div`
  ${TypographyV2.s1};
  width: 100%;
`;

export const TooltipWorker = styled.div`
  ${TypographyV2.s1};
  width: 100%;
`;

export const ShiftTypeBadge = styled.div`
  position: absolute;
  top: -8px;
  right: -16px;
  z-index: 2;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: ${ColorV2.Blue6};
  border: 3px solid ${ColorV2.White};
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;
